// src/pages/Users/TechniquesQuizz/quizUtils.js

// Mélange in-place
export function shuffleArray(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = (Math.random() * (i + 1)) | 0;
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Renvoie une image dispo sur la technique
function getTechniqueImage(t) {
  return t?.image1_url || t?.image_url || t?.image || "/img/placeholder.jpg";
}

/**
 * Construit un set de questions
 * @param {Array} techniques - liste brute des techniques
 * @param {Object} options
 *   - grade: string ("Toutes les ceintures" ou "Jaune", etc.)
 *   - count: nombre de questions (default 10)
 *   - wrongCount: nb de mauvaises réponses à proposer (default 3)
 */
export function buildQuestions(
  techniques = [],
  { grade = "Toutes les ceintures", count = 10, wrongCount = 3 } = {}
) {
  if (!Array.isArray(techniques) || techniques.length === 0) return [];

  const pool =
    grade === "Toutes les ceintures"
      ? techniques
      : techniques.filter((t) => t.ceinture === grade);

  if (pool.length === 0) return [];

  // Mélange et prend N techniques comme base des questions
  const seeds = shuffleArray(pool).slice(0, Math.min(count, pool.length));

  const allNames = techniques.map((t) => t.nom);
  const questions = seeds.map((tech) => {
    const correct = tech.nom;

    // Mauvaises réponses prioritairement dans la même famille
    const sameFam = techniques.filter(
      (t) => t.famille === tech.famille && t.id !== tech.id
    );
    let wrongs = shuffleArray(sameFam)
      .map((t) => t.nom)
      .filter((n) => n !== correct);

    // Complète si pas assez d'items dans la famille
    if (wrongs.length < wrongCount) {
      const others = shuffleArray(
        allNames.filter((n) => n !== correct && !wrongs.includes(n))
      );
      wrongs = wrongs.concat(others.slice(0, wrongCount - wrongs.length));
    } else {
      wrongs = wrongs.slice(0, wrongCount);
    }

    const options = shuffleArray([correct, ...wrongs]);

    return {
      id: tech.id,
      image: getTechniqueImage(tech),
      correctAnswer: correct,
      options,
      famille: tech.famille,
    };
  });

  return questions;
}
